import { render, staticRenderFns } from "./batchImportAtfile.vue?vue&type=template&id=477f6cc4&scoped=true&"
import script from "./batchImportAtfile.vue?vue&type=script&lang=js&"
export * from "./batchImportAtfile.vue?vue&type=script&lang=js&"
import style0 from "./batchImportAtfile.vue?vue&type=style&index=0&id=477f6cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f6cc4",
  null
  
)

export default component.exports